import { getBasicListInitialState, getBasicListReducerSlice } from '@probatix/common/utils/service'

import { Product } from '@probatix/common/services/RTKServices/checkoutSteps/checkoutStepsService.model'

import { STATE_KEY } from '../productService.constants'

export const slice = getBasicListReducerSlice<Product[]>(getBasicListInitialState(), STATE_KEY)

export default slice.reducer
